export const ACCOUNT_CONFIRMATION_PATH = '/account-confirmation';
export const EMAIL_CONFIRMATION_PATH = '/email-confirmation';
export const GROUP_INVITATION_PATH = '/group-mail';
export const ACCOUNT_PATH = '/account';
export const ACCOUNT_OPTIONS_PATH = '/options';
export const LEGAL_CONFIRMATION_PATH = '/legal-confirmation';
